import React from 'react';
import Spa16 from '../Spa16';
import Spa24 from '../Spa24';

import ChaMeta04 from '../ChaMeta04';
import { ICON } from 'resources/constants';

import {
  Input,
  ElementWrapper,
  InputWrapper,
  MetaWrapper,
  Popup,
  PopupText,
  PopupTextError,
  ChallengeName,
  LeftIcon,
  RightIcon,
  ParticipateButton,
} from './elements';

type Props = {
  readonly className?: string;
  readonly teamName: string;
  readonly sectionName: string;
  readonly challengeName: string;
  readonly placeholder: string;
  readonly participateClicked: () => void;
  readonly participateButtonDisabled?: boolean;
  readonly isValidating?: boolean;
  readonly validCode?: boolean;
  readonly checkingText: string;
  readonly participateText: string;
  readonly error?: string;
  readonly value: string;
  readonly onChange: (event) => void;
  readonly 'aria-labelledby': string;
};

export default function CaCoIn(props: Props): React.ReactElement {
  if (props.isValidating) {
    return (
      <ElementWrapper className={props.className}>
        <InputWrapper>
          <Input
            aria-labelledby={props['aria-labelledby']}
            value={props.value}
            onChange={props.onChange}
            placeholder={props.placeholder}
          />
        </InputWrapper>
        <Popup>
          <PopupText>{props.checkingText}</PopupText>
        </Popup>
      </ElementWrapper>
    );
  }

  if (props.error) {
    return (
      <ElementWrapper className={props.className}>
        <InputWrapper>
          <Input
            aria-labelledby={props['aria-labelledby']}
            value={props.value}
            onChange={props.onChange}
            placeholder={props.placeholder}
          />
        </InputWrapper>
        <Popup>
          <PopupTextError>{props.error}</PopupTextError>
        </Popup>
      </ElementWrapper>
    );
  }

  if (props.validCode) {
    return (
      <ElementWrapper className={props.className}>
        <InputWrapper>
          <Input
            aria-labelledby={props['aria-labelledby']}
            value={props.value}
            onChange={props.onChange}
            placeholder={props.placeholder}
          />
        </InputWrapper>
        <Popup>
          <ChallengeName>{props.challengeName}</ChallengeName>
          <Spa16 />
          <MetaWrapper>
            <LeftIcon icon={ICON.team} />
            <ChaMeta04 title={props.teamName}>{props.sectionName}</ChaMeta04>
            <RightIcon icon={ICON.check} />
          </MetaWrapper>
          <Spa24 />
          <ParticipateButton
            onClick={props.participateClicked}
            disabled={props.participateButtonDisabled}
          >
            {props.participateText}
          </ParticipateButton>
        </Popup>
      </ElementWrapper>
    );
  }

  return (
    <ElementWrapper className={props.className}>
      <InputWrapper>
        <Input
          aria-labelledby={props['aria-labelledby']}
          value={props.value}
          onChange={props.onChange}
          placeholder={props.placeholder}
        />
      </InputWrapper>
    </ElementWrapper>
  );
}
